import qs from 'qs'

export const createUrl = (state) => `?${qs.stringify(state)}`

export const searchStateToUrl = (searchState) =>
  searchState ? createUrl(searchState) : ''

export const urlToSearchState = ({ search }) =>
  search ? qs.parse(search.slice(1)) : {}
